

































import Component from "vue-class-component";
import {Prop, Vue} from "vue-property-decorator";
import pdf from "vue-pdf";
import {faSearchMinus, faSearchPlus, faExpandAlt} from "@fortawesome/free-solid-svg-icons";

@Component({
    components: {pdf}
})
export default class PdfDisplay extends Vue {
    totalPages = 0;
    currentPage = 1;
    @Prop() src!:string | null;
    icons = {faSearchMinus, faSearchPlus, faExpandAlt};
    zoom = 1;
    zoomLevels = [0.5, 1, 1.5, 2, 4];
    zoomIndex = 1;
    full = false;

    toggleFull() {
        this.full = !this.full;
    }

    zoomIn() {
        if (this.zoomIndex < this.zoomLevels.length - 1)
            this.zoomIndex++;
        this.zoom = this.zoomLevels[this.zoomIndex];
    }

    zoomOut() {
        if (this.zoomIndex > 0)
            this.zoomIndex--;
        this.zoom = this.zoomLevels[this.zoomIndex];
    }
}

